(function(){
  var d=document.documentElement; d.classList.add('u-js');
  var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init(root){
    var els=(root||document).querySelectorAll('[data-u-reveal]:not(.is-in)');
    if(reduce||!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return;}
    var io=new IntersectionObserver(function(entries){entries.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}})},{rootMargin:'0px 0px -8% 0px',threshold:0.08});
    els.forEach(function(e){io.observe(e)});
  }
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){init()})}else{init()}
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
  document.querySelectorAll('[data-u-scroller]').forEach(function(s){
    var bar=s.parentNode.querySelector('.u-progress i'); if(!bar) return;
    s.addEventListener('scroll',function(){var m=s.scrollWidth-s.clientWidth; bar.style.transform='scaleX('+(m>0?(0.25+0.75*s.scrollLeft/m):1)+')';},{passive:true});
  });
})();